var map = {
	"./account_borrowings.svg": 5795,
	"./account_locations.svg": 43525,
	"./account_return_rate.svg": 59862,
	"./account_return_time.svg": 21579,
	"./account_users.svg": 52649,
	"./all_locations.svg": 35069,
	"./apple.svg": 3249,
	"./arrow.svg": 57190,
	"./bluetooth.svg": 77411,
	"./bowl.svg": 76755,
	"./client.svg": 5766,
	"./cloud_upload.svg": 43510,
	"./collect_money.svg": 72114,
	"./cup.svg": 73753,
	"./dnd.svg": 35647,
	"./done.svg": 56903,
	"./download.svg": 91303,
	"./error.svg": 45119,
	"./filters.svg": 87968,
	"./give_money.svg": 80965,
	"./icon_marker.svg": 67625,
	"./inventory_counts_benefit_1.svg": 80928,
	"./inventory_counts_benefit_2.svg": 51827,
	"./inventory_counts_benefit_3.svg": 72834,
	"./inventory_counts_benefit_4.svg": 47501,
	"./inventory_counts_benefit_5.svg": 67788,
	"./languages/de.svg": 85570,
	"./languages/en.svg": 29994,
	"./languages/fr.svg": 74727,
	"./languages/nl.svg": 50297,
	"./languages/sv.svg": 57144,
	"./location_stats_borrowings.svg": 84589,
	"./location_stats_return_rate.svg": 67116,
	"./location_stats_return_time.svg": 11029,
	"./location_stats_users.svg": 21327,
	"./menu_card_upgrade.svg": 55058,
	"./menu_card_upgrade_active.svg": 5343,
	"./menu_contact.svg": 86279,
	"./menu_contact_active.svg": 39936,
	"./menu_deposit.svg": 27757,
	"./menu_deposit_active.svg": 63558,
	"./menu_faq.svg": 16803,
	"./menu_faq_active.svg": 44900,
	"./menu_history.svg": 96975,
	"./menu_history_active.svg": 8024,
	"./menu_home.svg": 34568,
	"./menu_home_active.svg": 95789,
	"./menu_infopoint.svg": 36437,
	"./menu_infopoint_active.svg": 24286,
	"./menu_inventory.svg": 59583,
	"./menu_inventory_active.svg": 39464,
	"./menu_inventory_counts.svg": 97014,
	"./menu_inventory_counts_active.svg": 65371,
	"./menu_locations.svg": 23367,
	"./menu_locations_active.svg": 80672,
	"./menu_profile.svg": 56660,
	"./menu_profile_active.svg": 6241,
	"./menu_qr_code.svg": 29976,
	"./menu_qr_code_active.svg": 26781,
	"./menu_relevos.svg": 26513,
	"./menu_relevos_active.svg": 29890,
	"./menu_relevos_assign.svg": 72127,
	"./menu_relevos_assign_active.svg": 47976,
	"./menu_relevos_quick_contacts.svg": 53939,
	"./menu_relevos_quick_contacts_active.svg": 55060,
	"./menu_relevos_report_damage.svg": 37174,
	"./menu_relevos_report_damage_active.svg": 11483,
	"./menu_relevos_return.svg": 67862,
	"./menu_relevos_return_active.svg": 46715,
	"./menu_reports.svg": 26318,
	"./menu_reports_active.svg": 73187,
	"./menu_retter_relevos.svg": 88684,
	"./menu_retter_relevos_active.svg": 54889,
	"./menu_settings.svg": 15762,
	"./menu_settings_active.svg": 99423,
	"./microsoft-windows.svg": 40749,
	"./money.svg": 45649,
	"./pdf_icon.svg": 69069,
	"./photo-camera.svg": 67279,
	"./pin.svg": 92528,
	"./qr_code_2_gray.svg": 10973,
	"./qr_code_2_gray200.svg": 44109,
	"./qr_code_black.svg": 54522,
	"./qr_code_orange.svg": 13319,
	"./qr_code_red.svg": 68586,
	"./qr_icon.svg": 86726,
	"./relevo_logo_white.svg": 22404,
	"./return-icon.svg": 46397,
	"./total_saves.svg": 93164,
	"./total_users.svg": 67830,
	"./upgrade.svg": 20697,
	"./user.svg": 10698,
	"./warning.svg": 42865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25853;